import "./BlueButton.scss";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

// { text, size, variant, type, icon, onClick, loading, path, vendorType }
const BlueButton = (props) => {
  const getSizeStyle = () => {
    switch (props?.size) {
      case "small":
        return { width: "100px" };
      case "medium":
        return { width: "150px" };
      case "large":
        return { width: "200px" };
      case "full":
        return { width: "100%" };
      case "fit":
        return { width: "fit-content" };
      default:
        return {};
    }
  };

  const sizeStyle = getSizeStyle();
  const navigate = useNavigate();

  const handleClick = () => {
    if (props?.path) {
      // Check if vendorType is provided and add it as a query parameter
      if (props.vendorType) {
        navigate(`${props.path}?vendorType=${props.vendorType}`);
      } else {
        navigate(props.path);
      }
    }
    if (props?.onClick) {
      props.onClick();
    }
  };

  return (
    <button
      type={props?.type || "button"}
      className={`outlined-blue ${
        props?.variant === "fill" ? "fill-blue" : ""
      } ${props.loading ? "loading" : ""}`}
      style={sizeStyle}
      onClick={handleClick}
      disabled={props.loading}
    >
      {props.loading ? (
        <CircularProgress size={24} color="inherit" />
      ) : (
        <>
          {props?.icon && props?.icon}
          {props?.text}
        </>
      )}
    </button>
  );
};

export default BlueButton;
